module.exports = __webpack_public_path__ + "img/bb_g3_t_nose-05.d51c13ed.svg";